export const accessBits = {
  None: 0,
  Select: 1,
  Update: 2,
  Insert: 4,
  Delete: 8,
  All: 15
};
